import { useTheme } from '@mui/material';
import React, { HTMLAttributes } from 'react';
import { Heading3Container } from './styles';

interface IHeading3Props extends HTMLAttributes<HTMLHeadingElement> {
  fontWeight?: 'XB' | 'B' | 'Sb' | 'Md' | 'Rg';
}

const Heading3 = ({
  children,
  fontWeight = 'Rg',
  ...props
}: IHeading3Props) => {
  const theme = useTheme();
  return (
    <Heading3Container
      {...props}
      style={{
        ...props.style,
        fontWeight: theme.typography?.fontWeight?.[fontWeight] || 400,
      }}
    >
      {children}
    </Heading3Container>
  );
};

export default Heading3;
